const trackingMenu = document.querySelector('.js-tracking-wrapper');
if (trackingMenu) {
	import('./scripts/trackingMenu').then(module => {
		module;
	});
}
